var _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _circle4, _circle5, _circle6, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtWaiting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 168.5,
  cy: 78.5,
  r: 43.5,
  fill: "#223B90"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 163.5,
  cy: 75.5,
  r: 43.5,
  fill: "#3863F0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m153.853 73.427 4.423-3.712a1 1 0 0 1 1.473.21l15.067 22.446c.667.995-.66 2.109-1.524 1.279l-19.489-18.736a1 1 0 0 1 .05-1.487Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m154.656 76.062-3.856-4.135a1 1 0 0 1 .173-1.512l14.867-9.998c.944-.635 2.046.547 1.347 1.444l-11.01 14.134a1 1 0 0 1-1.521.067Z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 41,
  r: 4,
  fill: "#F8B24F"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 199,
  cy: 71,
  r: 4,
  fill: "#F8B24F"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 77,
  r: 4,
  fill: "#F8B24F"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 111,
  r: 4,
  fill: "#F8B24F"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F56B57",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M107 73c-1.667-5.5-2.1-18.6 9.5-27M93.876 69c-1.667-5.5-2.1-18.6 9.5-27M222.314 87.903c1.377 5.58 1.124 18.685-10.9 26.466M235.211 92.585c1.377 5.58 1.124 18.684-10.9 26.466"
})));
export default SvgArtWaiting;